import { Geolocation } from './geolocation';
import { Filter } from './filter';
import { SortCriteria } from './sortcriteria';
import { Location } from './Location';
import { mutation } from 'vuex-class-component';

export class ATSJobListParams {
  public location!: string;
  public Location: Location = new Location();
  public geoLocation: Geolocation = new Geolocation();
  public keywords: string = '';
  public filter: Filter = new Filter();
  public sortCriteria: SortCriteria = new SortCriteria();
  public resultSize: number = 10;
  public resultPage: number = 1;
}
